import { useEffect, useState } from 'react';

const useVisualViewport = () => {
  const [viewport, setViewport] = useState({
    width: 0,
    height: 0,
  });

  useEffect(() => {
    if (!window.visualViewport) return;

    const handler = () => {
      if (!window.visualViewport) return;
      setViewport({
        width: window.visualViewport.width,
        height: window.visualViewport.height,
      });
    };

    setViewport({
      width: window.visualViewport.width,
      height: window.visualViewport.height,
    });

    window.visualViewport.addEventListener('resize', handler);
    window.visualViewport.addEventListener('scroll', handler);

    return () => {
      if (!window.visualViewport) return;

      window.visualViewport.removeEventListener('resize', handler);
      window.visualViewport.removeEventListener('scroll', handler);
    };
  }, []);

  return viewport;
};

export default useVisualViewport;
